module.exports = __webpack_public_path__ + "img/03060067.5d3c5906.jpg";